module.exports = __webpack_public_path__ + "static/media/tv.8da0ab50.png";